import React from 'react';
import RemovedComponentNotice from '../components/Component/RemovedComponentNotice';

/** Display-only stubs for types removed from the active registry. */
export const REMOVED_COMPONENT_TOMBSTONES = [
  {
    name: 'knowledge_bank',
    displayName: 'Content Library',
    logo: '/svgs/knowledge.svg',
    baseColor: '#a880e8',
  },
  {
    name: 'workflow_data',
    displayName: 'Query Workflow Data',
    logo: '/svgs/query_database.svg',
    baseColor: '#09347B',
  },
];

const REMOVED_FACTORY_DEFAULTS = {
  description: 'Legacy component removed from the palette',
  stateless: false,
  interactive: false,
  tier: 'FREE',
  isTrigger: false,
  hasAccessControl: false,
  isAlwaysPublic: false,
  isExcluded: true,
  isFloatingIcon: false,
  isRemoved: true,
  hasInput: true,
  hasOutput: true,
};

export function expandRemovedTombstone(tombstone) {
  return { ...REMOVED_FACTORY_DEFAULTS, ...tombstone };
}

/** Full registry-shaped entries for canvas factory lookup only. */
export const REMOVED_COMPONENT_REGISTRY_ENTRIES = REMOVED_COMPONENT_TOMBSTONES.map(
  expandRemovedTombstone,
);

const REMOVED_BY_NAME = Object.fromEntries(
  REMOVED_COMPONENT_TOMBSTONES.map(entry => [entry.name, entry]),
);

export function isRemovedComponentType(type) {
  return type != null && REMOVED_BY_NAME[type] != null;
}

export function getRemovedComponentMeta(type) {
  return REMOVED_BY_NAME[type] ?? null;
}

export function getRemovedComponentDisplayName(type) {
  return REMOVED_BY_NAME[type]?.displayName ?? '';
}

/** Shared read-only editor for removed component types (pane + inline config). */
export function renderRemovedComponentEditor(type, props = {}) {
  if (!isRemovedComponentType(type)) return null;
  return <RemovedComponentNotice componentType={type} {...props} />;
}
